<div id="videoLayout" class="panel panel-default">
	<div id="videoDisplayRegion"></div>
	<div id="videoControlRegion" class="panel-footer"></div>
</div>	